
<div class="flow-picto-wrapper" :shape="shape" :animate="animate" :type="type" :state="state">
	<div
		class="flow-picto-container"
		:size="size"
		:state="state"
		:borderState="borderState"
		:type="type"
		:effects="effects"
		:shape="shape"
		:style="styleObj"
		:loading="loading"
		@click="handleClick($event)"
	>
		<span class="flow-picto-content">
			<slot>
				{{ computedLabel }}
			</slot>
		</span>

		<svg v-if="shape === 'squircle'" width="0" height="0">
			<defs>
				<clipPath id="squircle" clipPathUnits="objectBoundingBox">
					<path d="M .5,0 C .1,0 0,.1 0,.5 0,.9 .1,1 .5,1 .9,1 1,.9 1,.5 1,.1 .9,0 .5,0 Z" />
				</clipPath>
			</defs>
		</svg>
	</div>
	<div v-if="$slots['title']" class="flow-picto-title">
		<slot name="title" />
	</div>
	<div v-if="$slots['number']" class="flow-picto-number">
		<slot name="number" />
	</div>
</div>
